import { useCallback } from 'react'
import { NavigateOptions, To, useNavigate } from 'react-router-dom'

/**
 * Custom hook that provides code-based navigation between React routes.
 * Dispatches @@loaded/reactNavigation with reactInternal: true so AngularJS
 * syncs its $location without triggering $urlRouter.sync(), avoiding
 * unnecessary AngularJS state transitions and DOM flickering.
 *
 * Use this hook when navigating between React routes.
 * Use useAngularJSNavigate when navigating from React to AngularJS routes.
 */
export function useReactNavigate() {
  const navigate = useNavigate()

  const reactNavigate = useCallback(
    (url: To | number, options?: NavigateOptions) => {
      if (typeof url === 'number') {
        navigate(url)
        return
      }

      window.dispatchEvent(
        new CustomEvent('@@loaded/reactNavigation', {
          detail: {
            to: typeof url === 'string' ? url : url.pathname,
            reactInternal: true,
          },
        })
      )
      navigate(url, { replace: false, ...options })
    },
    [navigate]
  )

  return reactNavigate
}
